import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import MailIcon from "@material-ui/icons/Mail";
import React from "react";

const useStyles = makeStyles((theme) => ({
  container: {
    background: "#0A0A0A",
    width: "100%",
    paddingBottom: "60px",
    paddingTop: "60px",
    borderTop: "1px solid #1E1E1E",
  },
  title: {
    color: "#FFFFFF",
    fontWeight: 600,
    fontSize: "1.5rem",
    marginBottom: "8px",
    textAlign: "center",
  },
  subtitle: {
    color: "#B0B0B0",
    fontSize: "1rem",
    marginBottom: "32px",
    textAlign: "center",
  },
  iconContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "24px",
    marginBottom: "40px",
  },
  icon: {
    fontSize: 80,
    color: "#FFFFFF",
    padding: "20px",
    borderRadius: "12px",
    border: "1px solid #2A2A2A",
    transition: "all 0.3s ease",
    display: "inline-block",
    "&:hover": {
      color: "#00FF41",
      borderColor: "#00FF41",
      backgroundColor: "rgba(0, 255, 65, 0.1)",
      transform: "translateY(-4px)",
      boxShadow: "0 10px 20px rgba(0, 255, 65, 0.2)",
    },
  },
  contactLink: {
    textDecoration: "none",
    display: "inline-flex",
  },
  copyright: {
    color: "#707070",
    fontSize: "0.85rem",
    textAlign: "center",
  },
  privacy: {
    color: "#707070",
    fontSize: "0.78rem",
    marginTop: "10px",
    textAlign: "center",
  },
  privacyLink: {
    color: "#B0B0B0",
    textDecoration: "none",
    "&:hover": {
      color: "#00FF41",
    },
  },
  highlight: {
    color: "#00FF41",
  },
}));

export default function Contact() {
  const classes = useStyles();

  return (
    <Grid item xs={12} className={classes.container}>
      <span id="contact"></span>
      <Container maxWidth="md">
        <Typography className={classes.title}>Let's Connect</Typography>
        <Typography className={classes.subtitle}>
          Feel free to reach out for collaborations or just a friendly hello
        </Typography>

        <div className={classes.iconContainer}>
          <a href="mailto:olms2074@gmail.com" className={classes.contactLink}>
            <MailIcon className={classes.icon} />
          </a>

          <a
            href="https://github.com/Bolmstead"
            className={classes.contactLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <GitHubIcon className={classes.icon} />
          </a>

          <a
            href="https://www.linkedin.com/in/berkleyolmstead/"
            className={classes.contactLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <LinkedInIcon className={classes.icon} />
          </a>
        </div>

        <Typography className={classes.copyright}>
          <span className={classes.highlight}>Berkley Olmstead</span> likes to
          code
        </Typography>
        <Typography className={classes.privacy}>
          <a className={classes.privacyLink} href="/privacy">
            Privacy
          </a>
        </Typography>
      </Container>
    </Grid>
  );
}
